import {
    Checkbox,
    FormControl,
    Grid,
    InputAdornment,
    InputLabel,
    ListItem,
    makeStyles,
    MenuItem,
    Select,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
} from "@material-ui/core"
import { AddAPhoto } from "@material-ui/icons"
import { useSnackbar } from "notistack"
import { useRef } from "react"
import { redimensionarPara300x300 } from "../../../functions/imagens"
import { inativarOpcao, inativarProduto } from "../../../services/cardapio"
import useAppStore from "../../../stores/AppStore"
import useLoadingStore from "../../../stores/LoadingStore"
import { useCheckboxContext } from "./CheckboxContext"
import DisponibilidadeSwitch from "./DisponibilidadeSwitch"

const useStyles = makeStyles(theme => ({
    listItem: {
        minWidth: "90vw",
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
        backgroundColor: "#fff",
        borderRadius: 15,
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        border: "1px solid #f0f0f0",
        transition: "all 0.3s ease",
        "&:hover": {
            boxShadow: "0 4px 15px rgba(0,0,0,0.12)",
            transform: "translateY(-2px)",
        },
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1.5),
            marginBottom: theme.spacing(1.5),
            borderRadius: 12,
        },
    },
    containerImg: {
        margin: "auto",
        maxWidth: "100px",
        height: "100px",
        backgroundColor: "#f8f9fa",
        border: "2px dashed #dee2e6",
        cursor: "pointer",
        overflow: "hidden",
        borderRadius: "12px",
        transition: "all 0.3s ease",
        "&:hover": {
            borderColor: "#2196f3",
            backgroundColor: "#e3f2fd",
        },
        [theme.breakpoints.down("sm")]: {
            maxWidth: "70px",
            height: "70px",
            borderRadius: "10px",
        },
    },
    addAPhoto: {
        width: "40%",
        height: "40%",
        color: "#adb5bd",
        transition: "color 0.3s ease",
        "$containerImg:hover &": {
            color: "#2196f3",
        },
    },
    textoImg: {
        color: "rgba(0,0,0,0.5)",
    },
    input: {
        display: "none",
    },
    textos: {
        fontWeight: 600,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        width: "100%",
        color: "#495057",
        fontSize: "0.75rem",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        marginBottom: theme.spacing(0.5),
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.7rem",
        },
    },
    nomeItem: {
        width: "100%",
        fontSize: "0.95rem",
        fontWeight: 500,
        color: "#212529",
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.85rem",
        },
    },
    descricaoTexto: {
        maxWidth: "100%",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
        fontSize: "0.9rem",
        color: "#6c757d",
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.8rem",
        },
    },
    campoInput: {
        "& .MuiOutlinedInput-root": {
            borderRadius: 10,
            backgroundColor: "#fff",
            transition: "all 0.3s ease",
            "&:hover": {
                backgroundColor: "#f8f9fa",
            },
            "&.Mui-focused": {
                backgroundColor: "#fff",
            },
        },
    },
    checkboxContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        [theme.breakpoints.down("sm")]: {
            position: "absolute",
            top: theme.spacing(1),
            left: theme.spacing(1),
            zIndex: 1,
        },
    },
    contentContainer: {
        [theme.breakpoints.down("sm")]: {
            paddingLeft: theme.spacing(5),
        },
    },
    descricaoContainer: {
        [theme.breakpoints.down("sm")]: {
            display: "none",
        },
    },
    camposContainer: {
        [theme.breakpoints.down("sm")]: {
            marginBottom: theme.spacing(2),
        },
    },
}))

export default function ItemMassa({
    index,
    produto,
    handleInputChange,
    handleCadastrarImagem,
    setItems,
    estabelecimento,
}) {
    const autorizacao = localStorage.getItem("chaveSistema")
    const setLoading = useLoadingStore(s => s.setLoading)
    const { enqueueSnackbar } = useSnackbar()
    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

    const configs = useAppStore(s => s.configuracoes)
    const parametros = configs.user.parametros

    const item = produto

    const fileInputRef = useRef(null)
    const handleDivClick = () => {
        fileInputRef.current.click()
    }

    const handleFileChange = async event => {
        const file = event.target.files[0]
        if (!file) return

        try {
            const file300 = await redimensionarPara300x300(file)
            const nomeArquivo = file.name
            const idProduto = item.tipo === "P" ? produto.id : item.produto
            const idOpcao = item.tipo === "O" ? produto.id : null
            const idPasso = null
            const edicaoMassa = true

            const response = await handleCadastrarImagem(
                nomeArquivo,
                idProduto,
                idPasso,
                idOpcao,
                file300,
                edicaoMassa
            )

            setItems(prev => {
                const newItems = [...prev]
                if (item.tipo === "P") {
                    newItems[index].urlImagemProduto = response
                } else {
                    newItems[index].urlImagemOpcao = response
                }
                return newItems
            })
        } catch (error) {
            alertStart(`${error}`, "error")
        }
    }

    const classes = useStyles()

    const { checkedItems, toggleItem } = useCheckboxContext()
    const checked = checkedItems[item.id] || false

    const handleChangeCodigoPDV = e => {
        item.codigoPDV = e.target.value
    }

    const handleChangeDisponibilidadeProduto = async () => {
        setLoading(true)
        const response = await inativarProduto(item?.id, item?.ativo, autorizacao)
        if (response.retornoErro) {
            console.error(response)
            alertStart(response.mensagem, "error")
        } else {
            item.ativo = !item.ativo
            alertStart("Disponibilidade do produto alterada com sucesso", "success")
        }
        setLoading(false)
    }

    const handleChangeDisponibilidadeOpcao = async () => {
        setLoading(true)
        const response = await inativarOpcao(item?.id, item?.ativo, autorizacao)
        if (response.retornoErro) {
            console.error(response)
            alertStart(response.mensagem, "error")
        } else {
            item.ativo = !item.ativo
            alertStart("Disponibilidade da opção alterada com sucesso", "success")
        }
        setLoading(false)
    }

    return (
        <ListItem key={item?.id} className={classes.listItem}>
            <Grid className={classes.checkboxContainer}>
                <Checkbox color="primary" onChange={() => toggleItem(item?.id)} checked={checked} />
            </Grid>
            <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                className={classes.contentContainer}
            >
                <Grid xs={12} sm={12} md={4} item container alignItems="center" spacing={1}>
                    <Grid
                        className={classes.containerImg}
                        item
                        container
                        justifyContent="center"
                        alignItems="center"
                        onClick={handleDivClick}
                        xs={4}
                        sm={6}
                        md={4}
                    >
                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                        >
                            {!item.urlImagemProduto && !item.urlImagemOpcao ? (
                                <Grid
                                    container
                                    direction="column"
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    <AddAPhoto className={classes.addAPhoto} />
                                </Grid>
                            ) : (
                                <img
                                    loading="lazy"
                                    style={{
                                        borderRadius: "12px",
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        objectPosition: "center",
                                    }}
                                    src={
                                        item.tipo === "P"
                                            ? item.urlImagemProduto
                                            : item.urlImagemOpcao
                                    }
                                    alt="Uploaded"
                                />
                            )}
                        </Grid>
                        <input
                            type="file"
                            ref={fileInputRef}
                            onChange={handleFileChange}
                            className={classes.input}
                            accept="image/*"
                        />
                    </Grid>
                    <Grid item container xs={8} sm={6} md={8} direction="column">
                        <Typography className={classes.textos}>
                            {item.tipo === "P" ? "Produto" : "Adicional"}
                        </Typography>
                        <Typography className={classes.nomeItem}>{item.nome}</Typography>
                    </Grid>
                </Grid>
                <Grid
                    xs={12}
                    sm={4}
                    md={6}
                    container
                    justifyContent="center"
                    spacing={1}
                    className={classes.camposContainer}
                >
                    <Grid item xs={12} sm={6} md={3} className={classes.descricaoContainer}>
                        {item?.tipo === "O" ? (
                            <>
                                <Typography className={classes.textos}>
                                    Passo de Montagem
                                </Typography>
                                <Typography className={classes.descricaoTexto}>
                                    {item?.grupo?.slice(0, 40)}
                                </Typography>
                            </>
                        ) : (
                            <>
                                <Typography className={classes.textos}>Descrição</Typography>
                                <Typography className={classes.descricaoTexto}>
                                    {item?.descricao?.slice(0, 40)}
                                </Typography>
                            </>
                        )}
                    </Grid>
                    {parametros.impressaoAlternada && (
                        <Grid
                            item
                            xs={12}
                            sm={6}
                            md={3}
                            style={{ marginTop: isMobile ? "1.2rem" : "0px" }}
                        >
                            <FormControl
                                fullWidth
                                variant="outlined"
                                size="small"
                                className={classes.campoInput}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            >
                                <InputLabel>Impressora</InputLabel>
                                <Select
                                    label="Impressora"
                                    defaultValue={item.impressaoAlternada}
                                    onChange={e => (item.impressaoAlternada = e.target.value)}
                                >
                                    <MenuItem value={0}> - </MenuItem>
                                    <MenuItem value={1}> 1ª impressora </MenuItem>
                                    <MenuItem value={2}> 2ª impressora </MenuItem>
                                    <MenuItem value={3}> 3ª impressora </MenuItem>
                                    <MenuItem value={4}> 4ª impressora </MenuItem>
                                    <MenuItem value={5}> 5ª impressora </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    )}
                    <Grid
                        item
                        xs={6}
                        sm={6}
                        md={item.impressaoAlternada === 0 || item.impressaoAlternada ? 3 : 4}
                        container
                        direction="column"
                        justifyContent="center"
                    >
                        <TextField
                            type="text"
                            id="codigoPDV"
                            fullWidth
                            variant="outlined"
                            size="small"
                            label="Código PDV"
                            className={classes.campoInput}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            placeholder="Código PDV"
                            defaultValue={item.codigoPDV}
                            onChange={handleChangeCodigoPDV}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={6}
                        sm={6}
                        md={item.impressaoAlternada === 0 || item.impressaoAlternada ? 3 : 4}
                    >
                        <TextField
                            type="number"
                            id={`inputValorMassa${item.id}`}
                            fullWidth
                            variant="outlined"
                            size="small"
                            className={classes.campoInput}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">R$</InputAdornment>
                                ),
                            }}
                            inputProps={{
                                style: { textAlign: "right" },
                                placeholder: "0.00",
                            }}
                            label="Preço"
                            value={item.valor}
                            onChange={e => handleInputChange(item.id, e.target.value)}
                        />
                    </Grid>
                </Grid>
                <Grid container xs={12} sm={4} md={2} justifyContent="center">
                    <DisponibilidadeSwitch
                        produto={item.grupo ? false : true}
                        disponivel={item?.ativo}
                        handleChangeDisponibilidadeProduto={handleChangeDisponibilidadeProduto}
                        handleChangeDisponibilidadeOpcao={handleChangeDisponibilidadeOpcao}
                    />
                </Grid>
            </Grid>
        </ListItem>
    )
}
